<div class="chatbot-container">
    <!-- Floating Button -->
    <button pButton pRipple type="button" icon="pi pi-comment" class="p-button-rounded p-button-primary chatbot-fab"
        (click)="toggleChat()"></button>

    <!-- Chat Window -->
    <div *ngIf="visible" class="chat-window shadow-6">
        <div class="chat-header">
            <span>Assistant IA</span>
            <button pButton pRipple type="button" icon="pi pi-times"
                class="p-button-rounded p-button-text p-button-plain p-button-sm" (click)="toggleChat()"></button>
        </div>

        <div class="chat-history">
            <div *ngIf="messages.length === 0" class="welcome-message text-center p-3 text-500">
                <i class="pi pi-bolt text-4xl mb-2"></i>
                <p>Bonjour! Je suis votre assistant maintenance. Posez-moi une question.</p>
            </div>

            <div *ngFor="let msg of messages" class="message mb-2"
                [ngClass]="{'user-message': msg.sender === 'user', 'ai-message': msg.sender === 'ai'}">
                <div class="message-bubble shadow-1">
                    {{ msg.text }}
                </div>
            </div>

            <div *ngIf="isLoading" class="message ai-message mb-2">
                <div class="message-bubble shadow-1">
                    <i class="pi pi-spin pi-spinner"></i> Réflexion en cours...
                </div>
            </div>
        </div>

        <div class="chat-input p-2 flex align-items-center gap-2">
            <input pInputText type="text" [(ngModel)]="userInput" (keydown.enter)="sendMessage()"
                placeholder="Posez une question..." class="flex-grow-1" [disabled]="isLoading">
            <button pButton pRipple type="button" icon="pi pi-send" class="p-button-rounded p-button-text"
                (click)="sendMessage()" [disabled]="!userInput.trim() || isLoading"></button>
        </div>
    </div>
</div>